export default __webpack_public_path__ + "static/media/0x88c949b4eb85a90071f2c0bef861bddee1a7479d.32713326.jpeg";